import { useContext, useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from "react-redux";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';

import CategoriesSuper from '../Categories/CategoriesSuper';
import { getLabConfig, getCategories } from '../../utils/api';

import MenuContext from '../../store/MenuContext';
import CategoryMenuClasses from '../Categories/CategoryMenu.module.css';


const XYZLABS_CustomComplete = () => {
	const navigate = useNavigate();
	const menuTheme = useContext(MenuContext);

    return (
		<div className={CategoryMenuClasses.categoryItemHeaderColumn}>
			<div>Customizable Order Complete Page</div>
			<div>
				<img src='../images/XYZLABS/XYZLABS_complete.jpg' alt='Step 1' style={{ marginTop: '10px' }}/>
			</div>
		</div>
    );
};

export default XYZLABS_CustomComplete;